import { StyledCell } from '../Table.style';
import styled from 'styled-components';
import { setQueryFilter } from 'components/GridChipFilterContainer/helpers';

const StyledServicesCell = styled(StyledCell)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const StyledServiceRow = styled.div`
  padding: 0.3rem;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

const ServiceRow = ({ service }) => {
  return (
    <StyledServiceRow onClick={() => setQueryFilter({ services: service.id })}>
      {service.name}
    </StyledServiceRow>
  );
};

const ServicesCell = ({ services }) => {
  return (
    <StyledServicesCell>
      {services.map(service => (
        <ServiceRow key={service.id} service={service} />
      ))}
    </StyledServicesCell>
  );
};

export default ServicesCell;
